/* eslint-disable react-hooks/exhaustive-deps */
import { Form } from 'antd'
import { useRouter } from 'next/router'
import { Project } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import React, { useState, useEffect } from 'react'
import { showNotification } from 'src/core/helpers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { resetTransferProjectState, transferProjectSelector } from 'src/features'
import { CustomModal, CustomTextInput, CustomTitle, CustomText } from 'src/components'
import ProjectTransferButtonsContent from './ProjectTransferButtonsContent/ProjectTransferButtonsContent'

interface PropsType {
  project: Project,
  isModalVisible: boolean,
  handleCancel: () => void
}

const ProjectTransferModal: React.FC<PropsType> = (props) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const router = useRouter()
  const [isConfirmVisible, setIsConfirmVisible] = useState<boolean>(false)
  const [emailTransfer, setEmailTransfer] = useState<string>(null)
  const { project, isModalVisible, handleCancel } = props

  const [form] = Form.useForm()

  const {
    success: successTransfer,
    error: errorTransfer
  } = useAppSelector(transferProjectSelector)


  const onFinish = ({ email }: { email: string }) => {
    setIsConfirmVisible(true)
    setEmailTransfer(email)
  }

  const handleOnCancel = (isFinishSuccess: boolean) => {
    form.resetFields()
    setEmailTransfer(null)
    setIsConfirmVisible(false)
    dispatch(resetTransferProjectState())
    if (isFinishSuccess) {
      router.push('/my-projects')
    }
    handleCancel()
  }

  useEffect(() => {
    if (successTransfer) {
      showNotification('success', t('general.OperationSuccess'))
      handleOnCancel(true)
    }
  }, [successTransfer])

  return (
    <CustomModal
      title={t(`Transfer Ownership: ${project.name}`)}
      open={isModalVisible}
      onCancel={() => handleOnCancel(false)}
      footer={null}
    >
      <div className='fade-animation'>
        <Form name='transferForm' form={form} onFinish={onFinish}>

          {/* Form Content */}
          {!isConfirmVisible ? (
            <>
              <CustomTitle label={t('admin.Brokerage.Email')} />
              <CustomTextInput
                name={'email'}
                placeholder={t('admin.Brokerage.EmailPlaceHolder')}
                type='email'
                required
              />
            </>
          ): (
            <>
              <div className='fade-animation'>
                <CustomTitle label={t('Projects.Transfer.Company', { emailTransfer })}/>
              </div>
              {errorTransfer && <div className='blink-animation'>
                <CustomText type='danger' label={t(`MyProjects.Transfer.Errors.${errorTransfer}`)} />
              </div>}
            </>
          )}

          {/* Buttons Section */}
          <ProjectTransferButtonsContent
            handleCancel={() => handleOnCancel(false)}
            isConfirmValdation={isConfirmVisible}
            email={emailTransfer}
            setIsConfirmVisible={() => setIsConfirmVisible(false)}
            projectId={project.id}
          />
        </Form>
      </div>
    </CustomModal>
  )
}

export default ProjectTransferModal
